import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import configureStore from './store/configureStore';
import Wrapper from './components/Wrapper';
import $ from 'jquery'
import config from './config';
// import SmartBannerAd from './SmartBannerAd';
function getCookie(c_name) {
    if (window.location.hostname == "gaming.uefa.com") {
        if ($($("#loader"))) {
            $($("#loader")).hide();
        }
        let cookieFound = false
        let i, x, y, cookiesArray = document.cookie.split(";");
        for (i = 0; i < cookiesArray.length; i++) {
            x = cookiesArray[i].substr(0, cookiesArray[i].indexOf("="));
            y = cookiesArray[i].substr(cookiesArray[i].indexOf("=") + 1);
            x = x.replace(/^\s+|\s+$/g, "");
            if (x === c_name) {
                cookieFound = true;

                return (y);
            }
        }
        if (!cookieFound) {
            $('link[href="/en/uclfantasy/static-assets/css/style.css?v=1"]').remove();
        }
    } else {
        return true
    }
}

const store = configureStore();

render(<Provider store={ store }>
    <div className={ "si-main-container " + (config.CURRENT_LANGUAGE == 'ru' ? 'si-ru' : '') }>
        {/* <SmartBannerAd/> */ }
        {/* { getCookie("showuclfantasy") ? <Wrapper /> : null } */ }
        { <Wrapper /> }

    </div>
</Provider>,
    document.getElementById('root-ucl-fantasy'));


// WEBPACK FOOTER //
// ./src/index.js